import { NgModule, NgModuleRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { ContentModule } from '@awp/content';
import { DynamicOutletModule, DynamicOutletRegistryService, RegistryItem } from '@awp/dynamic-outlet';
import { ApFormsModule } from '@awp/forms';

import { COMPONENTS, ENTRY_COMPONENTS } from './components';
import { PIPES } from './pipes';
import { DIRECTIVES } from './directives';

import { LocaleService } from './components/date-range-picker/locale.service';
import { LOCALE_CONFIG } from './components/date-range-picker/date-range-picker.config';
import { SERVICES } from './services';
import * as fromWidgets from './widgets';


const MATERIAL_MODULES = [
  MatToolbarModule,
  MatInputModule,
  MatSelectModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatIconModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatDatepickerModule,
  MatCheckboxModule,
  MatSidenavModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatDialogModule,
  MatExpansionModule,
  MatCardModule,
  MatDividerModule,
  PortalModule,
  OverlayModule,
  MatMenuModule,
  MatListModule,
  MatGridListModule,
  MatProgressBarModule
];

export const COMPONENT_REGISTER: RegistryItem[] = [
  {
    componentName: 'NavMenuWidgetComponent',
    componentType: fromWidgets.NavMenuWidgetComponent
  }
];


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ContentModule,
    RouterModule.forChild([]),
    ...MATERIAL_MODULES,
    DynamicOutletModule,
    ApFormsModule,
  ],
  declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES, ...fromWidgets.WIDGETS],
  entryComponents: [...ENTRY_COMPONENTS, ...fromWidgets.WIDGETS],
  exports: [CommonModule, ApFormsModule, ...COMPONENTS, ...PIPES, ...DIRECTIVES, ...MATERIAL_MODULES, ...fromWidgets.WIDGETS],
  providers: [
    { provide: LOCALE_CONFIG, useValue: {} },
    { provide: LocaleService, useClass: LocaleService, deps: [LOCALE_CONFIG] },
    SERVICES
  ]
})
export class CommonUiModule {

  constructor(
    moduleRef: NgModuleRef<CommonUiModule>,
    dynamicOutletRegistry: DynamicOutletRegistryService) {
    dynamicOutletRegistry.register(CommonUiModule.name, COMPONENT_REGISTER, moduleRef);
  }

}
